import { render, staticRenderFns } from "./det.vue?vue&type=template&id=2689837a&scoped=true"
import script from "./det.vue?vue&type=script&lang=js"
export * from "./det.vue?vue&type=script&lang=js"
import style0 from "./det.vue?vue&type=style&index=0&id=2689837a&prod&lang=css"
import style1 from "./det.vue?vue&type=style&index=1&id=2689837a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2689837a",
  null
  
)

export default component.exports